export default "__VITE_ASSET__BoA4EVqz__"